export default __webpack_public_path__ + "static/welcome-mobile-ad38e2e68a7ace3173d0341115fa030d.svg";